import type {
  TeaserBaseProps,
  TeaserBodyDecoratorsProps,
  TeaserFooterProps,
  TeaserHighlightProps,
  TeaserMediaProps,
  TeaserTextProps,
  TeaserThemeProps,
  TeaserVariantProps,
  TeaserVignetteProps,
} from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Body, Content, Media, Title, Vignette } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'
import { TeaserFooter } from '@bonniernews/dn-design-system-web/components/teaser-footer/teaser-footer.tsx'

export interface TeaserSplitProps
  extends TeaserBaseProps,
    TeaserThemeProps,
    TeaserHighlightProps,
    TeaserVignetteProps,
    TeaserVariantProps,
    TeaserMediaProps,
    TeaserTextProps,
    TeaserBodyDecoratorsProps,
    TeaserFooterProps {
  title: string
  areaType?: 'main' | 'bauta'
  variant?: 'default' | 'podcast'
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-split](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-split)
 * - Storybook: [TeaserSplit](https://designsystem.dn.se/?path=/docs/section-teasersplit--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-split/teaser-split.scss'`
 */
export const TeaserSplit = ({
  title,
  targetLink,
  variant,
  areaType,
  theme,
  text,
  vignette,
  highlight,
  sticker,
  media,
  isFlashingDot,
  publicationTime,
  duration,
  attributes = {},
  classNames,
}: TeaserSplitProps) => {
  const componentClassName = 'ds-teaser'

  const classes = formatClassString(['ds-teaser--split', variant && `${componentClassName}--${variant}`, classNames])

  return (
    <TeaserCard targetLink={targetLink} areaType={areaType} theme={theme} classNames={classes} {...attributes}>
      <Media media={media} rounded={true} />
      <Content>
        <Vignette vignette={vignette} variant={variant} />
        <Title title={title} highlight={highlight} />
        <Body text={text} sticker={sticker} isFlashingDot={isFlashingDot} />
        {variant === 'podcast' && (
          <TeaserFooter footerVariant='podcast' publicationTime={publicationTime} duration={duration} />
        )}
      </Content>
    </TeaserCard>
  )
}
